import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "@/features/auth/hooks/useAuth";
import { Button } from "@/shared/components/ui/Button";

const OFFICER_TYPES = ["officer", "admin"];

export const LeavePage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { userData } = useAuth();
  const isOfficer = OFFICER_TYPES.includes(userData?.userType?.toLowerCase() || "");

  return (
    <div>
      {/* Header */}
      <div className="flex flex-col gap-3 mb-6 md:flex-row md:items-center md:justify-between">
        <h1 className="text-xl md:text-2xl font-bold text-gray-900">
          {t("leave.title")}
        </h1>
        <Button onClick={() => navigate("/leave/apply")} className="flex-1 md:flex-none">
          {t("leave.apply_for_leave")}
        </Button>
      </div>

      {/* Quick links */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {/* Apply Card */}
        <button
          onClick={() => navigate("/leave/apply")}
          className="bg-white rounded-xl border border-gray-200 p-5 text-left hover:border-indigo-300 hover:shadow-sm transition-all active:scale-[0.98]"
        >
          <div className="w-10 h-10 rounded-lg bg-indigo-100 flex items-center justify-center mb-3">
            <svg className="w-5 h-5 text-indigo-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
            </svg>
          </div>
          <h3 className="text-sm font-semibold text-gray-900 mb-1">{t("leave.apply_for_leave")}</h3>
          <p className="text-xs text-gray-500">
            {t("leave.apply_desc")}
          </p>
        </button>

        {/* Submissions Card (All users) */}
        <button
          onClick={() => navigate("/leave/submissions")}
          className="bg-white rounded-xl border border-gray-200 p-5 text-left hover:border-indigo-300 hover:shadow-sm transition-all active:scale-[0.98]"
        >
          <div className="w-10 h-10 rounded-lg bg-green-100 flex items-center justify-center mb-3">
            <svg className="w-5 h-5 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" />
            </svg>
          </div>
          <h3 className="text-sm font-semibold text-gray-900 mb-1">{t("leave.view_submissions")}</h3>
          <p className="text-xs text-gray-500">
            {isOfficer ? t("leave.view_submissions_desc") : t("leave.view_my_submissions_desc")}
          </p>
        </button>

        {/* Form Builder Card (Officer only) */}
        {isOfficer && (
          <button
            onClick={() => navigate("/leave/builder")}
            className="bg-white rounded-xl border border-gray-200 p-5 text-left hover:border-indigo-300 hover:shadow-sm transition-all active:scale-[0.98]"
          >
            <div className="w-10 h-10 rounded-lg bg-purple-100 flex items-center justify-center mb-3">
              <svg className="w-5 h-5 text-purple-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.066 2.573c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.573 1.066c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.066-2.573c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
            </div>
            <h3 className="text-sm font-semibold text-gray-900 mb-1">{t("leave.form_builder")}</h3>
            <p className="text-xs text-gray-500">
              {t("leave.form_builder_desc")}
            </p>
          </button>
        )}
      </div>
    </div>
  );
};
